module.exports = __webpack_public_path__ + "static/media/medium-pink.1c20fcf7.svg";